class Base2Repository {
  async prepare() {
    if (this.prepared) {
      return;
    }

    //this.mPersistence = await this.getPersistenceProvider().getInstance();
    this.mService = await this.getServiceProvider().getInstance();

    this.prepared = true;
  }

  async fetch({
    filters = [],
    order = [],
    pagination = { page: 1, perPage: 25 },
    group = false,
    transforms = []
  }) {
    return await this.mService.fetch({
      filters,
      order,
      pagination,
      group,
      transforms
    });
  }

  async get(url, params) {
    return await this.mService.networkGet(url, { params });
  }

  async create(params) {
    return await this.mService.create(params);
  }

  async update(uuid, params) {
    return await this.mService.update(uuid, params);
  }

  async destroy(uuid) {
    return await this.mService.destroy(uuid);
  }

  stream({ filters = [], order = [], group = false }) {
    return callback =>
      this.mService.stream({ filters, order, group }, callback);
  }
}

export default Base2Repository;



// WEBPACK FOOTER //
// ./src/core/repository/base2.repository.js